import { Box, HStack, Text, IconButton, Menu, MenuButton, MenuList, MenuItem, MenuDivider } from '@chakra-ui/react';
import { FiMoreVertical, FiVolumeX, FiVolume2, FiMaximize, FiMinimize, FiDownload, FiRefreshCw, FiShare2 } from 'react-icons/fi';
import IconWrapper from './IconWrapper';

interface VideoSettingsProps {
  isMuted: boolean;
  isFullscreen: boolean;
  onMuteToggle: () => void;
  onFullscreenToggle: () => void;
  onDownload: () => void;
  onRefresh: () => void;
  onShare: () => void;
}

const VideoSettings: React.FC<VideoSettingsProps> = ({
  isMuted,
  isFullscreen,
  onMuteToggle,
  onFullscreenToggle,
  onDownload,
  onRefresh,
  onShare
}) => {
  return (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="More options"
        icon={<IconWrapper icon={FiMoreVertical} size={20} />}
        variant="ghost"
        colorScheme="white"
      />
      <MenuList bg="gray.800" borderColor="gray.600" zIndex={100}>
        <MenuItem 
          icon={<IconWrapper icon={isMuted ? FiVolumeX : FiVolume2} size={16} />}
          onClick={onMuteToggle}
          bg="gray.800"
          _hover={{ bg: "gray.700" }}
        >
          {isMuted ? 'Unmute' : 'Mute'}
        </MenuItem>
        <MenuItem 
          icon={<IconWrapper icon={isFullscreen ? FiMinimize : FiMaximize} size={16} />}
          onClick={onFullscreenToggle}
          bg="gray.800"
          _hover={{ bg: "gray.700" }}
        >
          {isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
        </MenuItem>
        <MenuItem 
          icon={<IconWrapper icon={FiDownload} size={16} />}
          onClick={onDownload}
          bg="gray.800"
          _hover={{ bg: "gray.700" }}
        >
          Download Video
        </MenuItem>
        <MenuDivider borderColor="gray.600" />
        <MenuItem 
          icon={<IconWrapper icon={FiRefreshCw} size={16} />}
          onClick={onRefresh}
          bg="gray.800"
          _hover={{ bg: "gray.700" }}
        >
          Refresh Video
        </MenuItem>
        <MenuItem 
          icon={<IconWrapper icon={FiShare2} size={16} />}
          onClick={onShare}
          bg="gray.800"
          _hover={{ bg: "gray.700" }}
        >
          Share Video
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default VideoSettings;
